import { Injectable } from "@angular/core";
import { StateType } from "./enums/enums";
import { TranslateService } from "@ngx-translate/core";
import {map} from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class StatesService {

    readonly STATE_ENUM_TRANSLATION_PREFIX: string = 'stateType_';
    constructor(private translate: TranslateService) {}

    public getStateName(countryCode): Observable<StateType> {
        if (StateType.hasOwnProperty(countryCode)) {
            return this.translate.get(this.STATE_ENUM_TRANSLATION_PREFIX + countryCode);
        } else {
            return countryCode;
        }
    }

    public getStatesKeys() {
      return StateType;
    }

    public getStatesKeyValue() : Observable<{id: string, name: string}[]> {
        let statesBeforeTranslate: string[] = [];
        for (let property in StateType) {
            statesBeforeTranslate.push(this.STATE_ENUM_TRANSLATION_PREFIX + StateType[property]);
        }

        return this.translate.get(statesBeforeTranslate).pipe(map(translatedStates => {
            const properties = [];
            for (let property in translatedStates) {
                properties.push({ id: property.replace(this.STATE_ENUM_TRANSLATION_PREFIX, ''), name: translatedStates[property]});
            }
            return properties;
        }));
    }
}